'use client';

import { createContext } from 'react';

export type ModalType = 'profile' | 'profileImageChange' | 'collectionCreate';
export type DrawerType = 'search' | 'userMenu';

export interface UIOverlayContextType {
  isAuthorizedPage: boolean;
  isOpen: {
    profile: boolean;
    profileImageChange: boolean;
    collectionCreate: boolean;
    search: boolean;
    userMenu: boolean;
  };
  handleOpen: (type: ModalType | DrawerType, id?: number) => void;
  handleClose: (type: ModalType | DrawerType) => void;
}

const UIOverlayContext = createContext<UIOverlayContextType>({
  isAuthorizedPage: false,
  isOpen: {
    profile: false,
    profileImageChange: false,
    collectionCreate: false,
    search: false,
    userMenu: false,
  },
  handleOpen: () => {},
  handleClose: () => {},
});

export default UIOverlayContext;
